import React from 'react';
import Script from 'react-load-script';

const TRACKING_ID = 'UA-24573557-9';

var loadScript = function (src) {
    if (typeof window !== 'undefined' && !window.dataLayer && typeof navigator !== 'undefined' && navigator.userAgent.indexOf("Speed Insights") == -1) {
        const script = document.createElement("script");
        script.src = "https://www.googletagmanager.com/gtag/js?id=" + TRACKING_ID;
        script.async = true;
        document.body.appendChild(script);

        window.dataLayer = window.dataLayer || [];
        function gtag() { dataLayer.push(arguments); }
        gtag('js', new Date());
        gtag('config', TRACKING_ID);
    }
}

const TrackerScript = ({ gridItems }) => (
    <span>
        {loadScript()}
    </span>
);

export default TrackerScript;


// WEBPACK FOOTER //
// ./src/components/TrackerScript.js